import { Controller } from "@hotwired/stimulus"

interface WaToast extends HTMLElement {
  create: (
    message: string,
    options: Record<string, unknown>,
  ) => Promise<unknown>
}

// Connects to data-controller="preview-disabled"
// Uses capture-phase listeners on targets to intercept clicks before
// other Stimulus actions fire, showing a toast instead.
export default class extends Controller {
  static targets = ["intercept", "toast"]

  declare readonly interceptTargets: Element[]
  declare readonly toastTarget: WaToast

  interceptTargetConnected(target: Element) {
    target.addEventListener("click", this.intercept, { capture: true })
  }

  interceptTargetDisconnected(target: Element) {
    target.removeEventListener("click", this.intercept, { capture: true })
  }

  private intercept = (event: Event) => {
    event.preventDefault()
    event.stopImmediatePropagation()
    this.showToast()
  }

  private showToast() {
    void this.toastTarget.create(
      "Preview only — this is your space so this action is disabled",
      {
        variant: "warning",
        duration: 3000,
      },
    )
  }
}
